import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Box, Link, List, ListItem, ListItemButton, ListItemText, Stack } from '@mui/material';

export default function EventoEscolhaPopover(props) {
    const { anchorEl, setAnchorEl, type, data, eventos, onEventoEscolhido } = props;
    //   const [anchorEl, setAnchorEl] = React.useState(null);

    //   const handleClick = (event) => {
    //     setAnchorEl(event.currentTarget);
    //   };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'evento-popover' : undefined;

    React.useEffect(() => {
        if (open) {
            console.log('>>>monta<<<')
        }
    }, [open])

    const visivel = React.useMemo(
        () => filtro(),
        [open]
    );
    function filtro() {
        let arr = eventos.filter(e => {
            const dtInicial = new Date(e.dtInicial);
            return (data.getMonth() === dtInicial.getMonth() && dtInicial.getFullYear() === data.getFullYear() );
        });
        arr = arr.sort((a,b)=> a.nomeCurto.toUpperCase().localeCompare( b.nomeCurto.toUpperCase()));
        return arr;
    }
    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
        // return dt.toLocaleTimeString();
    }
    function handleEscolhe(row){
        onEventoEscolhido(row);
        handleClose();
    }    
    return (
        <div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >                
                <Box sx={{ width: '100%', maxWidth: 460, maxHeight:400, bgcolor: 'background.paper', overflow: 'auto', }}>
                    <List component="nav">
                        {visivel && visivel.map((row, id) => (
                            <ListItemButton key={id} onClick={() => handleEscolhe(row) }>
                                <ListItemText
                                    primary={row.nomeCurto}
                                    secondary={ formataData(row.dtInicial) }
                                />
                            </ListItemButton>
                        ))}
                    </List>
                </Box>
            </Popover>
        </div>
    );
}
